import React from 'react'

const IconEndConnector = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <g clipPath="url(#clip0_5657_16987)">
        <mask
          id="mask0_5657_16987"
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="16"
          height="16"
        >
          <rect width="16" height="16" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_5657_16987)">
          <path
            d="M8.66634 10.334H13.333V5.66732H8.66634V10.334ZM7.33301 11.6673V8.66732H1.33301V7.33398H7.33301V4.33398H14.6663V11.6673H7.33301Z"
            fill="white"
            fillOpacity="0.45"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_5657_16987">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default IconEndConnector
